var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassImg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 12,
  viewBox: "0 0 20 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.83333 0C2.61167 0 0 2.68629 0 6C0 9.31371 2.61167 12 5.83333 12C8.47556 12 10.7051 10.1923 11.4225 7.71429H15V10.2857H18.3333V7.71429H20V4.28571H11.4225C10.7051 1.80772 8.47556 0 5.83333 0ZM5.83333 3.42857C7.21417 3.42857 8.33333 4.57971 8.33333 6C8.33333 7.42029 7.21417 8.57143 5.83333 8.57143C4.4525 8.57143 3.33333 7.42029 3.33333 6C3.33333 4.57971 4.4525 3.42857 5.83333 3.42857Z",
  fill: "#F7F7F7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pass-img.31a9f090f037e9b8a9c9d553117a6485.svg";